// #region Errores de HTMX

interface DetalleAntesIntercambioHtmx {
	xhr: { status: number; };
	shouldSwap: boolean;
	isError: boolean;
}

interface EventoAntesIntercambioHtmx extends Event { detail: DetalleAntesIntercambioHtmx; }

document.body.addEventListener('htmx:beforeSwap', (event: Event) => { // Permite que HTMX inserte el fragmento HTML de error en el widget destino, sin tratar la respuesta como un error que bloquee la interfaz.

	const eventoTipado = event as EventoAntesIntercambioHtmx;
	if (eventoTipado.detail.xhr.status >= 400) {
		eventoTipado.detail.shouldSwap = true;
		eventoTipado.detail.isError = false;
	}

});


interface DetalleErrorRespuestaHtmx {
	xhr: { status: number; };
	pathInfo: { requestPath: string; };
}

interface EventoErrorRespuestaHtmx extends Event { detail: DetalleErrorRespuestaHtmx; }

document.addEventListener('htmx:responseError', (event: Event) => { // Captura errores de respuesta del servidor (Ej: 500, 403, 404) de CloudFlare de solicitudes que no alcanzaron a llegar al Worker: Limitación de llamadas configurada en CloudFlare, caída temporal de CloudFlare, etc.

	const eventoTipado = event as EventoErrorRespuestaHtmx;
	const estado = eventoTipado.detail.xhr.status;
	const ruta = eventoTipado.detail.pathInfo.requestPath;
	console.error(`[HTMX] Error ${estado} en la ruta: ${ruta}`);
	alert(document.documentElement.lang === 'es'
		? `Error del servidor (${estado}). Por favor, intenta de nuevo.`
		: `A server error occurred (${estado}). Please try again.`);

});


document.addEventListener('htmx:sendError', () => { // Captura errores de conectividad del usuario.

	console.error('[HTMX] Error de red: No se pudo enviar la solicitud.');
	alert(document.documentElement.lang === 'es'
		? 'No hay conexión a internet. Revisa tu señal.'
		: 'No internet connection. Please check your signal.');

});

// #endregion


// #region Carrusel de acciones

type RaizConsultaInterfaz = Document | Element;

function InicializarCarruselAcciones(raiz: RaizConsultaInterfaz = document): void { // Sustituye el carrusel basado en radios por un indice activo pequeno y facil de mantener.

	const carruselesAcciones = Array.from(raiz.querySelectorAll<HTMLElement>('[data-acciones-carrusel]'));
	if (carruselesAcciones.length === 0) return;

	for (const carruselAcciones of carruselesAcciones) {

		if (carruselAcciones.dataset.accionesCarruselInicializado === 'true') continue;

		const etiquetas = Array.from(carruselAcciones.querySelectorAll<HTMLElement>('[data-accion-etiqueta]'));
		const paneles = Array.from(carruselAcciones.querySelectorAll<HTMLElement>('[data-accion-panel]'));
		const botonAnterior = carruselAcciones.querySelector<HTMLButtonElement>('[data-accion-direccion="anterior"]');
		const botonSiguiente = carruselAcciones.querySelector<HTMLButtonElement>('[data-accion-direccion="siguiente"]');

		if (etiquetas.length === 0 || paneles.length === 0 || etiquetas.length !== paneles.length || !botonAnterior || !botonSiguiente)
			continue;

		let indiceActivo = etiquetas.findIndex((etiqueta) => etiqueta.classList.contains('es-activa'));
		if (indiceActivo < 0 || indiceActivo >= etiquetas.length) indiceActivo = 0;

		const aplicarEstadoAccion = (indiceNuevo: number): void => {

			indiceActivo = (indiceNuevo + etiquetas.length) % etiquetas.length;

			etiquetas.forEach((etiqueta, indiceEtiqueta) => {
				etiqueta.classList.toggle('es-activa', indiceEtiqueta === indiceActivo);
				etiqueta.classList.toggle('es-anterior', indiceEtiqueta < indiceActivo);
			});

			paneles.forEach((panel, indicePanel) => {

				const estaActivo = indicePanel === indiceActivo;
				panel.classList.toggle('es-activa', estaActivo);
				panel.classList.toggle('es-anterior', indicePanel < indiceActivo);
				panel.setAttribute('aria-hidden', estaActivo ? 'false' : 'true');

			});

		};

		botonAnterior.addEventListener('click', () => {
			aplicarEstadoAccion(indiceActivo - 1);
		});

		botonSiguiente.addEventListener('click', () => {
			aplicarEstadoAccion(indiceActivo + 1);
		});

		carruselAcciones.addEventListener('keydown', (evento: KeyboardEvent) => {

			if (evento.key === 'ArrowLeft') {
				evento.preventDefault();
				aplicarEstadoAccion(indiceActivo - 1);
			}

			if (evento.key === 'ArrowRight') {
				evento.preventDefault();
				aplicarEstadoAccion(indiceActivo + 1);
			}

		});

		carruselAcciones.dataset.accionesCarruselInicializado = 'true';
		aplicarEstadoAccion(indiceActivo);

	}

}

// #endregion


// #region Carrusel de opiniones

function InicializarCarruselOpiniones(raiz: RaizConsultaInterfaz = document): void { // Sustituye el carrusel de radios por un desplazamiento minimo controlado desde JS.

	const carruselesOpiniones = Array.from(raiz.querySelectorAll<HTMLElement>('[data-opiniones-carrusel]'));
	if (carruselesOpiniones.length === 0) return;

	for (const carruselOpiniones of carruselesOpiniones) {

		if (carruselOpiniones.dataset.opinionesCarruselInicializado === 'true') continue;

		const pista = carruselOpiniones.querySelector<HTMLElement>('[data-opiniones-pista]');
		const opiniones = Array.from(carruselOpiniones.querySelectorAll<HTMLElement>('.opinion'));
		const botonAnterior = carruselOpiniones.querySelector<HTMLButtonElement>('[data-opinion-direccion="anterior"]');
		const botonSiguiente = carruselOpiniones.querySelector<HTMLButtonElement>('[data-opinion-direccion="siguiente"]');

		if (!pista || opiniones.length === 0 || !botonAnterior || !botonSiguiente) continue;

		let pasoActivo = 0;
		const consultaModoMovil = window.matchMedia('(max-width: 75rem)');
		const cantidadVisibleMovil = 1;
		const cantidadVisibleEscritorio = 3;

		const obtenerCantidadVisible = (): number => consultaModoMovil.matches ? cantidadVisibleMovil : cantidadVisibleEscritorio;


		const obtenerPasoMaximo = (): number => Math.max(0, opiniones.length - obtenerCantidadVisible());


		const aplicarPasoOpiniones = (pasoNuevo: number): void => {

			const pasoMaximo = obtenerPasoMaximo();
			pasoActivo = Math.min(Math.max(0, pasoNuevo), pasoMaximo);

			const opinionObjetivo = opiniones[pasoActivo];
			if (opinionObjetivo && pista) {
				const desplazamiento = opinionObjetivo.getBoundingClientRect().left - pista.getBoundingClientRect().left;
				pista.style.transform = `translateX(-${desplazamiento}px)`;
			}
			botonAnterior.disabled = pasoActivo === 0;
			botonSiguiente.disabled = pasoActivo === pasoMaximo;

		};

		botonAnterior.addEventListener('click', () => {
			aplicarPasoOpiniones(pasoActivo - 1);
		});

		botonSiguiente.addEventListener('click', () => {
			aplicarPasoOpiniones(pasoActivo + 1);
		});

		carruselOpiniones.addEventListener('keydown', (evento: KeyboardEvent) => {

			if (evento.key === 'ArrowLeft') {
				evento.preventDefault();
				aplicarPasoOpiniones(pasoActivo - 1);
			}

			if (evento.key === 'ArrowRight') {
				evento.preventDefault();
				aplicarPasoOpiniones(pasoActivo + 1);
			}

		});

		window.addEventListener('resize', () => {
			aplicarPasoOpiniones(pasoActivo);
		});

		carruselOpiniones.dataset.opinionesCarruselInicializado = 'true';
		aplicarPasoOpiniones(0);

	}

}

// #endregion


// #region Navegacion activa

function InicializarNavegacionActiva(): void { // Resalta el enlace del menu que corresponde a la seccion visible en el centro de la pantalla.

	if (!document.querySelector('.principal')) return;

	const secciones = [
		{ id: 'descarga', enlace: document.querySelector<HTMLElement>('a[href="/#descarga"]') },
		{ id: 'acciones', enlace: document.querySelector<HTMLElement>('a[href="/#acciones"]') },
		{ id: 'planes', enlace: document.querySelector<HTMLElement>('a[href="/#planes"]') },
	].filter((s): s is { id: string; enlace: HTMLElement; } => s.enlace !== null);

	if (secciones.length === 0) return;

	const observer = new IntersectionObserver((entries) => {

		const visible = entries
			.filter((e) => e.isIntersecting)
			.sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
		if (visible) {

			const id = visible.target.id;
			for (const seccion of secciones) {
				seccion.enlace.classList.toggle('es-activo', seccion.id === id);
			}

		}

	}, {
		rootMargin: '-45% 0px -45% 0px',
		threshold: 0,
	});

	for (const seccion of secciones) {
		const elemento = document.getElementById(seccion.id);
		if (elemento) observer.observe(elemento);
	}

}

// #endregion


// #region Detalles del historial de destellos

const ClavePreferenciaDetallesHistorial = 'dirai-historial-destellos-detalles-tecnicos';

function InicializarDetallesHistorial(raiz: RaizConsultaInterfaz = document): void { // Permite consultar la columna unificada de detalles técnicos solo cuando el usuario la necesita y conserva su eleccion local.

	const historialRaiz = raiz instanceof Element && raiz.matches('.historial-destellos')
		? raiz : raiz.querySelector<HTMLElement>('.historial-destellos');
	if (!historialRaiz) return;

	const controles = Array.from(historialRaiz.querySelectorAll<HTMLInputElement>('[data-historial-detalles]'));

	for (const control of controles) {

		if (control.dataset.historialDetallesInicializado === 'true') continue;

		const leerPreferencia = (): boolean => {

			try {
				return window.localStorage.getItem(ClavePreferenciaDetallesHistorial) === 'true';
			} catch {
				return false;
			}

		};


		const guardarPreferencia = (detallesVisibles: boolean): void => {

			try {
				window.localStorage.setItem(ClavePreferenciaDetallesHistorial, String(detallesVisibles));
			} catch { // El historial sigue funcionando aunque el navegador no permita almacenamiento local.
			}

		};


		const aplicarEstado = (detallesVisibles: boolean): void => {
			historialRaiz.classList.toggle('detalles-tecnicos-visibles', detallesVisibles);
			control.checked = detallesVisibles;
		};

		control.addEventListener('change', () => {

			const detallesVisibles = control.checked;
			aplicarEstado(detallesVisibles);
			guardarPreferencia(detallesVisibles);

		});

		control.dataset.historialDetallesInicializado = 'true';
		aplicarEstado(leerPreferencia());

	}

}


function CerrarInformacionDetallesHistorial(): void {

	const contenedoresAbiertos =
		Array.from(document.querySelectorAll<HTMLElement>('.historial-destellos-encabezado-detalles.es-abierto'));
	for (const contenedor of contenedoresAbiertos) {

		contenedor.classList.remove('es-abierto');
		const boton = contenedor.querySelector<HTMLButtonElement>('[data-historial-informacion-detalles]');
		boton?.setAttribute('aria-expanded', 'false');

	}

}


function PosicionarTooltipDetallesHistorial(boton: HTMLButtonElement, tooltip: HTMLElement): void {

	const rectánguloBotón = boton.getBoundingClientRect();
	const margen = 8;
	const anchoTooltip = tooltip.offsetWidth;
	const altoTooltip = tooltip.offsetHeight;
	const mitadTooltip = anchoTooltip / 2;
	const centroHorizontal = anchoTooltip > 0
		? Math.min(Math.max(rectánguloBotón.left + rectánguloBotón.width / 2, margen + mitadTooltip),
			window.innerWidth - margen - mitadTooltip)
		: rectánguloBotón.left + rectánguloBotón.width / 2;
	const posiciónDebajo = rectánguloBotón.bottom + margen;
	const posiciónEncima = rectánguloBotón.top - margen - altoTooltip;
	const posiciónVertical = altoTooltip > 0 && posiciónDebajo + altoTooltip > window.innerHeight - margen && posiciónEncima >= margen
		? posiciónEncima : posiciónDebajo;

	tooltip.style.setProperty('--historial-destellos-tooltip-left', `${centroHorizontal}px`);
	tooltip.style.setProperty('--historial-destellos-tooltip-top', `${posiciónVertical}px`);

}


function InicializarInformacionDetallesHistorial(raiz: RaizConsultaInterfaz = document): void { // Activa la leyenda accesible del encabezado Detalles despues de la carga inicial o de un intercambio HTMX.

	const botones = Array.from(raiz.querySelectorAll<HTMLButtonElement>('[data-historial-informacion-detalles]'));
	for (const boton of botones) {

		if (boton.dataset.historialInformacionDetallesInicializada === 'true') continue;
		const contenedor = boton.closest<HTMLElement>('.historial-destellos-encabezado-detalles');
		if (!contenedor) continue;
		const tooltip = contenedor.querySelector<HTMLElement>('.historial-destellos-tooltip-detalles');
		if (!tooltip) continue;
		const contenedorTabla = boton.closest<HTMLElement>('.historial-destellos-tabla-contenedor');
		const posicionarDespuésDeMostrar = (): void => {
			window.requestAnimationFrame(() => PosicionarTooltipDetallesHistorial(boton, tooltip));
		};
		boton.addEventListener('pointerenter', posicionarDespuésDeMostrar);
		boton.addEventListener('focus', posicionarDespuésDeMostrar);
		window.addEventListener('resize', posicionarDespuésDeMostrar);
		window.addEventListener('scroll', posicionarDespuésDeMostrar, { passive: true });
		contenedorTabla?.addEventListener('scroll', posicionarDespuésDeMostrar, { passive: true });

		boton.addEventListener('click', (evento: MouseEvent) => {

			evento.stopPropagation();
			CerrarInformacionDetallesHistorial();
			contenedor.classList.add('es-abierto');
			boton.setAttribute('aria-expanded', 'true');
			PosicionarTooltipDetallesHistorial(boton, tooltip);

		});

		boton.dataset.historialInformacionDetallesInicializada = 'true';

	}

}


document.addEventListener('click', (evento: MouseEvent) => {

	const objetivo = evento.target;
	if (!(objetivo instanceof Node)) return;
	const contenedorAbierto = document.querySelector<HTMLElement>('.historial-destellos-encabezado-detalles.es-abierto');
	if (!contenedorAbierto || contenedorAbierto.contains(objetivo)) return;
	const boton = contenedorAbierto.querySelector<HTMLButtonElement>('[data-historial-informacion-detalles]');
	CerrarInformacionDetallesHistorial();
	boton?.blur();

});


document.addEventListener('keydown', (evento: KeyboardEvent) => {

	if (evento.key !== 'Escape') return;
	const contenedorAbierto = document.querySelector<HTMLElement>('.historial-destellos-encabezado-detalles.es-abierto');
	if (!contenedorAbierto) return;
	const boton = contenedorAbierto.querySelector<HTMLButtonElement>('[data-historial-informacion-detalles]');
	CerrarInformacionDetallesHistorial();
	boton?.blur();

});

// #endregion


// #region Reintento del enlace mágico

function InicializarReintentoEnlace(raiz: RaizConsultaInterfaz = document): void { // Revela el enlace para volver al formulario de correo despues de un minuto sin mostrar una cuenta regresiva.

	const enlaces = Array.from(raiz.querySelectorAll<HTMLAnchorElement>('[data-reintento-enlace]'));
	if (enlaces.length === 0) return;

	for (const enlace of enlaces) {

		if (enlace.dataset.reintentoInicializado === 'true') continue;

		enlace.hidden = true;
		enlace.dataset.reintentoInicializado = 'true';
		window.setTimeout(() => {
			enlace.hidden = false;
		}, 60000);

	}

}

// #endregion


// #region Encabezado de portada

let EscuchasEncabezadoPortadaInicializadas = false;

function SincronizarEncabezadoPortada(): void { // Alinea el menu de la portada desde el centro hacia su posicion final en el borde derecho util del sitio.

	const encabezado = document.querySelector<HTMLElement>('.marco-encabezado');
	const logoMarco = document.querySelector<HTMLElement>('.marco-logo');
	const controlesMarco = document.querySelector<HTMLElement>('.marco-controles');
	const botonInstalacion = document.querySelector<HTMLElement>('.btn-instalacion');
	const heroPrincipal = document.querySelector<HTMLElement>('#descarga');
	const enlacePortable = document.querySelector<HTMLElement>('.enlace-portable');
	const portadaPrincipal = document.querySelector<HTMLElement>('.principal');

	if (!encabezado || !logoMarco || !controlesMarco || !botonInstalacion || !heroPrincipal || !enlacePortable || !portadaPrincipal) {

		if (logoMarco) logoMarco.style.opacity = '';
		if (controlesMarco) controlesMarco.style.transform = '';
		return;

	}

	const consultaMovimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)');

	controlesMarco.style.transform = 'translateX(0px)';

	const rectEncabezado = encabezado.getBoundingClientRect();
	const rectControles = controlesMarco.getBoundingClientRect();
	const estiloEncabezado = window.getComputedStyle(encabezado);
	const rellenoDerecho = Number.parseFloat(estiloEncabezado.paddingRight) || 0;
	const bordeDerechoUtil = rectEncabezado.right - rellenoDerecho;
	const desplazamientoFinal = bordeDerechoUtil - rectControles.right;
	const alturaHeroEscritorio = Math.max(0, (window.innerHeight - encabezado.offsetHeight) * 0.85);

	portadaPrincipal.style.setProperty('--principal-altura-hero-escritorio', `${alturaHeroEscritorio}px`);

	if (consultaMovimientoReducido.matches) {

		logoMarco.style.opacity = '1';
		controlesMarco.style.transform = `translateX(${desplazamientoFinal}px)`;
		return;

	}

	const inicioRecorrido = 0;
	const finRecorridoLogo = Math.max(encabezado.offsetHeight,
		(botonInstalacion.getBoundingClientRect().bottom + window.scrollY) - encabezado.offsetHeight);
	const finRecorridoMenu = Math.max(encabezado.offsetHeight,
		heroPrincipal.offsetTop + heroPrincipal.offsetHeight - encabezado.offsetHeight);
	const progresoLogoBruto = (window.scrollY - inicioRecorrido) / Math.max(1, finRecorridoLogo - inicioRecorrido);
	const progresoMenuBruto = (window.scrollY - inicioRecorrido) / Math.max(1, finRecorridoMenu - inicioRecorrido);
	const progresoLogo = Math.min(1, Math.max(0, progresoLogoBruto));
	const progresoMenu = Math.min(1, Math.max(0, progresoMenuBruto));

	logoMarco.style.opacity = `${progresoLogo}`;
	controlesMarco.style.transform = `translateX(${desplazamientoFinal * progresoMenu}px)`;

}


function InicializarEncabezadoPortada(): void { // Registra una sola vez las escuchas necesarias para recalcular el corrimiento del menu del encabezado.

	if (!document.querySelector('.principal')) return;

	SincronizarEncabezadoPortada();

	if (EscuchasEncabezadoPortadaInicializadas) return;

	window.addEventListener('scroll', SincronizarEncabezadoPortada, { passive: true });
	window.addEventListener('resize', SincronizarEncabezadoPortada);
	EscuchasEncabezadoPortadaInicializadas = true;

}

// #endregion


// #region Hero dinamico

type RaizConsultaHero = RaizConsultaInterfaz;

function BarajarRutasHero(rutas: string[]): string[] { // Mezcla las rutas del hero una sola vez al cargar para que cada recarga produzca un orden distinto.

	const rutasBarajadas = [...rutas];

	for (let indice = rutasBarajadas.length - 1; indice > 0; indice -= 1) {

		const indiceAleatorio = Math.floor(Math.random() * (indice + 1));
		const rutaTemporal = rutasBarajadas[indice];
		rutasBarajadas[indice] = rutasBarajadas[indiceAleatorio];
		rutasBarajadas[indiceAleatorio] = rutaTemporal;

	}

	return rutasBarajadas;

}


function InicializarHeroDinamico(raiz: RaizConsultaHero = document): void { // Activa la rotacion suave del hero desde un archivo permitido por la CSP de produccion.

	const contenedoresHero = Array.from(raiz.querySelectorAll<HTMLElement>('[data-hero-dinamico]'));
	if (contenedoresHero.length === 0) return;

	for (const contenedorHero of contenedoresHero) {

		if (contenedorHero.dataset.heroDinamicoInicializado === 'true') continue;

		const consultaMovimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)');
		const escenas = Array.from(contenedorHero.querySelectorAll<HTMLImageElement>('[data-hero-escena]'));
		let indiceActivo = 0;
		let temporizadorRotacion = 0;

		if (escenas.length === 0) continue;

		const rutasHero = escenas
			.map((escena) => escena.getAttribute('src') ?? escena.dataset.heroSrc ?? '')
			.filter((ruta): ruta is string => ruta.length > 0);

		const rutasHeroBarajadas = rutasHero.length > 1
			? [rutasHero[0], ...BarajarRutasHero(rutasHero.slice(1))]
			: rutasHero;

		escenas.forEach((escena, indiceEscena) => {

			const rutaBarajada = rutasHeroBarajadas[indiceEscena];
			escena.classList.toggle('es-activa', indiceEscena === 0);
			delete escena.dataset.heroCargada;

			if (!rutaBarajada) {

				escena.removeAttribute('src');
				delete escena.dataset.heroSrc;
				return;

			}

			if (indiceEscena === 0) {

				escena.src = rutaBarajada;
				escena.dataset.heroCargada = 'true';
				delete escena.dataset.heroSrc;
				escena.setAttribute('fetchpriority', 'high');
				return;

			}

			escena.removeAttribute('src');
			escena.dataset.heroSrc = rutaBarajada;
			escena.removeAttribute('fetchpriority');

		});

		const cargarEscena = (indiceEscena: number): Promise<void> => {

			const escena = escenas[indiceEscena];
			if (!escena) return Promise.resolve();
			if (escena.dataset.heroCargada === 'true') return Promise.resolve();

			const rutaHero = escena.dataset.heroSrc;
			if (!rutaHero) {
				escena.dataset.heroCargada = 'true';
				return Promise.resolve();
			}

			return new Promise((resolve) => {

				const cerrarCarga = (): void => {
					escena.dataset.heroCargada = 'true';
					resolve();
				};

				escena.addEventListener('load', cerrarCarga, { once: true });
				escena.addEventListener('error', cerrarCarga, { once: true });
				escena.src = rutaHero;
				delete escena.dataset.heroSrc;

				if (escena.complete) cerrarCarga();

			});

		};


		const mostrarEscena = (indiceNuevo: number): void => {

			indiceActivo = indiceNuevo;

			escenas.forEach((escena, indiceEscena) => {
				escena.classList.toggle('es-activa', indiceEscena === indiceNuevo);
			});

		};


		const detenerRotacion = (): void => {

			if (!temporizadorRotacion) return;
			window.clearInterval(temporizadorRotacion);
			temporizadorRotacion = 0;

		};


		const iniciarRotacion = (): void => {

			if (consultaMovimientoReducido.matches || escenas.length < 2 || temporizadorRotacion) return;

			temporizadorRotacion = window.setInterval(() => {

				void (async (): Promise<void> => {

					const indiceSiguiente = (indiceActivo + 1) % escenas.length;
					await cargarEscena(indiceSiguiente);
					mostrarEscena(indiceSiguiente);
					void cargarEscena((indiceSiguiente + 1) % escenas.length);

				})();

			}, 7500);

		};


		const sincronizarMovimiento = (): void => {

			detenerRotacion();
			mostrarEscena(0);
			void cargarEscena(1);
			if (!consultaMovimientoReducido.matches) iniciarRotacion();

		};

		contenedorHero.addEventListener('pointerenter', detenerRotacion);
		contenedorHero.addEventListener('pointerleave', iniciarRotacion);

		if (typeof consultaMovimientoReducido.addEventListener === 'function')
			consultaMovimientoReducido.addEventListener('change', sincronizarMovimiento);

		contenedorHero.dataset.heroDinamicoInicializado = 'true';
		sincronizarMovimiento();

	}

}


InicializarCarruselOpiniones();
InicializarCarruselAcciones();
InicializarHeroDinamico();
InicializarEncabezadoPortada();
InicializarNavegacionActiva();
InicializarDetallesHistorial();
InicializarInformacionDetallesHistorial();
InicializarReintentoEnlace();
document.body.addEventListener('htmx:afterSwap', (event: Event) => { // Reactiva el hero si la portada vuelve a entrar al DOM mediante un intercambio parcial.

	const objetivoIntercambio = event.target;
	if (!(objetivoIntercambio instanceof Element)) return;
	InicializarCarruselOpiniones(objetivoIntercambio);
	InicializarCarruselAcciones(objetivoIntercambio);
	InicializarHeroDinamico(objetivoIntercambio);
	InicializarEncabezadoPortada();
	InicializarNavegacionActiva();
	InicializarDetallesHistorial(objetivoIntercambio);
	InicializarInformacionDetallesHistorial(objetivoIntercambio);
	InicializarReintentoEnlace(objetivoIntercambio);

});

// #endregion
